import axios from 'axios';

/**
 * Configuration globale d'axios
 * 
 * En développement :
 * - Le proxy dans package.json redirige /api/* vers http://localhost:5000
 * - On utilise des chemins relatifs qui passent par le proxy
 * 
 * En production (Docker) :
 * - Nginx gère le proxy vers l'API (voir nginx.conf)
 * - Si REACT_APP_API_URL est défini, on l'utilise
 * - Sinon, on utilise des chemins relatifs (gérés par Nginx)
 */

const getApiBaseURL = () => {
    // Si REACT_APP_API_URL est défini, l'utiliser (production avec domaine personnalisé)
    if (process.env.REACT_APP_API_URL) {
        const apiUrl = process.env.REACT_APP_API_URL.trim();
        // Retirer le trailing slash si présent
        return apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
    }

    // En développement : le proxy dans package.json gère les requêtes
    // En production : Nginx gère le proxy, donc on utilise des chemins relatifs (vide = relatif)
    return '';
};

// Configurer le baseURL d'axios
axios.defaults.baseURL = getApiBaseURL();

// Configuration par défaut
axios.defaults.timeout = 30000; // 30 secondes
axios.defaults.headers.common['Content-Type'] = 'application/json';

// Intercepteur pour les requêtes (logging en développement)
if (process.env.NODE_ENV === 'development') {
    axios.interceptors.request.use(
        (config) => {
            const fullUrl = config.baseURL
                ? `${config.baseURL}${config.url}`
                : config.url;
            console.log(`[Axios] ${config.method?.toUpperCase()} ${fullUrl}`);
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
}

// Intercepteur pour les réponses (gestion des erreurs)
//
// 401 = token invalide / expiré (changement de JWT_SECRET, expiration 1d,
// user désactivé). On nettoie l'état d'auth local et on redirige vers
// /login si on est dans l'admin. Évite les pages admin coincées avec un
// token mort.
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            const url = error.config?.url || '';
            const path = typeof window !== 'undefined' ? window.location.pathname : '';
            const isLoginCall = url.includes('/api/auth/login');
            const isAdminPath = path.startsWith('/dashboard') || path.startsWith('/landing');

            // Ne pas auto-logout sur une tentative de login échouée
            // (le formulaire affiche déjà l'erreur).
            if (!isLoginCall && typeof window !== 'undefined') {
                localStorage.removeItem('jwtToken');
                delete axios.defaults.headers.common['Authorization'];

                if (isAdminPath) {
                    // Hard redirect pour reset complet du store + reload
                    window.location.href = '/login';
                }
            }
        }
        return Promise.reject(error);
    }
);

// Export par défaut pour compatibilité
export default axios;

// Export nommé pour utilisation explicite si nécessaire
export { axios };

